import React, { useState } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  BackHandler,
} from "react-native";

import { StackActions } from "@react-navigation/native";
import BackgroundUser from "../components/BackgroundUser";
import Title from "../components/Title";
import Logo from "../components/Logo";
import InputPersonas from "../components/InputPersonas";
import ButtonLayout from "../components/ButtonLayout";
import QRCode from "qrcode";
import { SvgXml } from "react-native-web-svg";

export default function (props) {
  const text =
    props.route.params.text !== undefined
      ? "" + props.route.params.text
      : "test";

  let xml = "";
  QRCode.toDataURL(
    text,
    {
      color: {
        dark: "#120f45",
        light: "#0000",
      },
    },
    function (err, url) {
      xml = url;
      console.log(url);
    }
  );
  return (
    <BackgroundUser scroll={true}>
      <Logo navigation={props.navigation}></Logo>
      <View
        style={{
          backgroundColor: "white",
          borderRadius: 30,
          width: 320,
          height: 320,
          alignSelf: "center",
          marginTop: 50,
          shadowColor: "#000",
          shadowOffset: {
            width: 0,
            height: 1,
          },
          shadowOpacity: 0.2,
          shadowRadius: 1.41,
          elevation: 2,
        }}>
        <Image
          source={{ uri: xml }}
          style={{ alignSelf: "center", height: 300, width: 300 }}
        />
        <Title style={{ marginTop: -30 }}>{text}</Title>
      </View>
      <Title style={{ fontSize: 15 }}>
        Presente esta pantalla al personal que se lo requiera
      </Title>
      <ButtonLayout
        style={{ alignSelf: "center" }}
        text='Volver'
        onPress={() => props.navigation.goBack()}
      />

      <View></View>
    </BackgroundUser>
  );
}
